import React, { useEffect } from "react";

import { useParams } from "react-router-dom";

import { Toast } from "@olist/design-system";
import { useApplication } from "@olist/microfrontend";

import { ERP } from "./components";
import { useToast } from "components/toast";
import { productToTitle } from "helpers/formatters";

export function NewTicket() {
  const param = useParams();
  const { toasts } = useToast();
  const context = useApplication();

  useEffect(() => {
    if (param.product !== undefined) {
      document.title = `Nova solicitação ${
        productToTitle[param?.product] || ""
      } - Central de ajuda`;
    }
  }, [param]);

  if (param.product === "erp") {
    return (
      <>
        <Toast toasts={toasts} />
        <ERP email={context?.user?.email || ""} />
      </>
    );
  }

  return <div>NewTicket</div>;
}
